import React from 'react'
import PropTypes from 'prop-types'
import { Transition } from 'semantic-ui-react'
import './global-loader.css'


const propTypes = { isLoading: PropTypes.bool }

const defaultProps = { isLoading: false }

const GlobalLoader = (props) => {
  const { isLoading } = props

  return (
    <div className={`frame ${isLoading ? '' : 'hiddenFrame'}`}>
      <Transition visible={isLoading} animation='fade up' duration={500}>
        <div className="center">
          <div className="dot1" />
          <div className="dot2" />
          <div className="dot3" />
        </div>
      </Transition>
    </div>
  )
}

GlobalLoader.propTypes = propTypes
GlobalLoader.defaultProps = defaultProps

export default GlobalLoader
